import React from "react";
import styled from "styled-components";
import FlexContainer from "../../Container/FlexContainer";
import PromoCard from "../shared/PromoCard";
import LinkList from "../DesktopNav/LinkList";

const StyledContainer = styled(FlexContainer)`
  flex-direction: column;
`;
const ExpandableContent = ({ content }) => {
  return (
    <>
      <StyledContainer>
        <PromoCard
          heading={content.promoHeading}
          image={content.promoImage}
          link={content.promoLink}
          secondaryLink={content.secondaryPromoLink}
        />
        <div>
          {content.lists.map((list, i) => (
            <LinkList key={`expandable_content_${i}`} list={list} />
          ))}
        </div>
      </StyledContainer>
    </>
  );
};
export default ExpandableContent;
